import { MenuOutlined } from "@ant-design/icons";
import { Button, Drawer, Layout } from "antd";
import cn from "classnames";
import { FC, PropsWithChildren, useEffect } from "react";
import { Link } from "react-router-dom";

// import { Chat } from "@app/features/chat/Chat";
import { useDevice } from "@app/shared/lib/DeviceProvider";
import { useDrawer, useLoc, useRouter, useSchool } from "@app/shared/lib/hooks";
import { useUser } from "@app/shared/lib/hooks/useUser";
import { SchoolLogo } from "@app/shared/ui/SchoolLogo";

import { Account } from "./Account/Account";
import { AdminMark } from "./AdminMark/AdminMark";
import { Chat } from "./Chat/Chat";
import { GamificationHeaderItem } from "./Gamification/Gamification";
import { Menu } from "./Menu/Menu";
import { Notifications } from "./Notifications/Notifications";

// import { useInstance } from 'react-ioc';
// import { HubClient } from '@axl/accel-framework/hub-client';
// import GamificationHeaderItem from './Gamification/Gamification';
import styles from "./Header.module.scss";

type HeaderItemProps = {
  onClick?: () => void;
};

const HeaderItem: FC<PropsWithChildren<HeaderItemProps>> = ({
  children,
  onClick,
}) => {
  return (
    <div
      className={cn(
        "flex align-center h-100 c-pointer no-select p-10 hoverable",
        styles.item,
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

type HeaderProps = {
  className?: string;
};

export const Header: FC<HeaderProps> & { Item: typeof HeaderItem } = ({
  className,
}) => {
  const user = useUser();
  const device = useDevice();
  const loc = useLoc();
  const school = useSchool();
  const { navigate } = useRouter();

  const mobileMenuDrawer = useDrawer();

  useEffect(() => {
    // autoclose menu on resize
    if (device.deviceSize === "desktop") mobileMenuDrawer.close();
  }, [device.deviceSize, mobileMenuDrawer]);

  return (
    <>
      <Layout.Header
        className={cn(
          styles.header,
          "flex justify-between shadow-sm bg-white",
          className,
        )}
      >
        <div className="flex flex-1 align-center h-100 overflow-hidden gap-10">
          {device.deviceSize !== "desktop" && (
            <Button
              onClick={() => mobileMenuDrawer.open()}
              type="text"
              size="large"
              icon={<MenuOutlined className="fs-20" />}
            />
          )}

          <Link to="/" className="flex">
            <SchoolLogo theme="dark" />
          </Link>

          {device.deviceSize === "desktop" && <Menu mode="horizontal" />}

          {user?.user?.session?.adminId != null && (
            <AdminMark session={user.user.session} />
          )}
        </div>

        <div className="flex align-center h-100 overflow-hidden">
          {school.gamification && (
            <GamificationHeaderItem onClick={() => navigate("/gamification")} />
          )}
          {school.supportChatEnabled && <Chat />}
          <Notifications />
          <Account />
        </div>
      </Layout.Header>

      <Drawer
        open={mobileMenuDrawer.visible}
        placement="left"
        onClose={() => mobileMenuDrawer.close()}
        title={loc.word("School.menuLabel", { default: "Menu" })}
        width={device.deviceSize === "mobile" ? "100%" : "300px"}
        destroyOnClose
        className="p-0"
      >
        <Menu mode="vertical" onSelect={() => mobileMenuDrawer.close()} />
      </Drawer>
    </>
  );
};

Header.Item = HeaderItem;
